import { Box, Radio, VStack } from "@chakra-ui/react"
import { addDays, formatDate, subtractDays } from "@utils/date"
import { NumericMenuConnectorParamsItem } from "instantsearch.js/es/connectors/numeric-menu/connectNumericMenu"
import { ChangeEvent } from "react"
import { useNumericMenu } from "react-instantsearch-core"

export const newReleasesOptions = (): NumericMenuConnectorParamsItem[] => {
  const currentDate = new Date()

  return [
    { label: "All" },
    {
      label: "Last 30 Days",
      start: Number(formatDate(subtractDays(currentDate, 30))),
      end: Number(formatDate(currentDate)),
    },
    {
      label: "Last 90 Days",
      start: Number(formatDate(subtractDays(currentDate, 90))),
      end: Number(formatDate(currentDate)),
    },
    {
      label: "Coming Soon",
      start: Number(formatDate(addDays(currentDate, 1))),
      end: 99999999,
    },
  ]
}

function NewReleasesFilter() {
  const { items, refine } = useNumericMenu({
    attribute: "datePublished",
    items: newReleasesOptions(),
  })

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    refine(event.target.value)
  }
  return (
    <VStack alignItems={"start"}>
      {items.map((item) => (
        <Radio
          key={item.value}
          isChecked={item.isRefined}
          onChange={handleChange}
          value={item.value}
          colorScheme={"yellow"}
        >
          <Box
            as={"span"}
            fontSize={"sm"}
          >
            {item.label}
          </Box>
        </Radio>
      ))}
    </VStack>
  )
}

export default NewReleasesFilter
